import { render } from "./RunBookLink.vue?vue&type=template&id=1f5861ec"
import script from "./RunBookLink.vue?vue&type=script&lang=js"
export * from "./RunBookLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__